import React from "react";

import { FnrCombobox } from "UI/FnrSelectList3";

import { months } from "Utilities/Date";
import { isValidMonthDay } from "Utilities/Date/isValidMonthDay";

import { useFnrDateInput2 } from "./FnrDatePicker2Context";

export default function MonthPicker({ focusColor, preventDefault, disabled }) {
  const { state, setMonth, setDay, setActiveField } = useFnrDateInput2();
  const { month, day, year } = state;

  const options = months.map((m) => {
    return { id: m.number, value: m.name };
  });

  function handleSelection(selection) {
    setMonth(selection);
    clearDayIfInvalid(selection);
    setActiveField("day");
  }

  function clearDayIfInvalid(month) {
    // For instance, if they have Dec 31 selected, and then change month to Feb...
    // we should then clear the day so that they can't try to save Feb 31.
    const isValid = isValidMonthDay({ month, day, year });
    if (!isValid && day) setDay(null);
  }

  function onClick(params) {
    let { open } = params;
    if (open) {
      setActiveField("");
    } else {
      setActiveField("month");
    }
  }

  const style = {
    background: "transparent",
    border: "none",
    padding: "6px 10px",
    fontWeight: 400,
    color: "#222",
    gap: "6px",
  };

  return (
    <div style={{ padding: "3px 3px" }}>
      <FnrCombobox
        className="month-picker"
        placeholder="Month"
        options={options}
        selection={parseInt(month) || 0}
        onSelect={handleSelection}
        iconColor={focusColor}
        iconSize="10px"
        style={style}
        onButtonClick={onClick}
        preventDefault={preventDefault}
        disabled={disabled}
      />
    </div>
  );
}
